import Highcharts from 'highcharts';

export function toggleLineType(value: string): void {
	if (!['spline', 'line'].includes(value)) return;

	// redraw all charts
	Highcharts.charts.forEach(function (chart) {
		if (!chart) return;
		const chartType = chart.options.chart?.type as string;
		const isXaxisDatetime = (chart.options.xAxis as any)[0]?.type === 'datetime';
		const shouldUpdate = isXaxisDatetime || chart.options.chart?.renderTo === 'frcst' || ['line', 'spline'].includes(chartType);
		if (!shouldUpdate) return;

		// update chart type
		chart.update({
			chart: {
				type: value,
			},
		}, false);
		chart.redraw();

	});
}
